import { IInputLoqateValue } from '@common/general-ui/input-loqate/input-loqate.component';
import { IIdObject } from '@common/interfaces/id-object.interface';
import { ICustomer } from '../registration-generated-api';
import { IPaymentSourceDto } from './payment-source.dto';

interface ICustomerCard {
    status: string;
    gateway: string;
    gateway_account_id: string;
    iin: string;
    last4: string;
    card_type: string;
    funding_type: string;
    expiry_month: number;
    expiry_year: number;
    issuing_country: string;
    created_at: number;
    updated_at: number;
    powered_by: 'not_applicable';
    resource_version: number;
    object: string;
    masked_number: string;
    customer_id: string;
    payment_source_id: string;
}

export interface ICustomerDto extends IIdObject {
    customer: Omit<ICustomer, 'shipping_address'>;
    paymentSource?: IPaymentSourceDto[];
    card?: ICustomerCard;
    billingAddress: IInputLoqateValue;
}

export const createCustomerDto = (source: ICustomer): ICustomerDto => {
    const billingAddress = source.customer?.billing_address;

    return {
        customer: source,
        billingAddress: {
            ...billingAddress,
            addressLine1: billingAddress?.line1 || '',
            addressLine2: billingAddress?.line2 || '',
            addressLine3: billingAddress?.line3 || '',
            country: billingAddress?.country || '',
            city: billingAddress?.city || '',
            postCode: billingAddress?.zip || '',
            label: [billingAddress?.line1, billingAddress?.line2, billingAddress?.city, billingAddress?.zip]
                .filter((f) => f)
                .join(', '),
            originalLabel: [billingAddress?.line1, billingAddress?.line2, billingAddress?.city, billingAddress?.zip]
                .filter((f) => f)
                .join(', '),
        },
        id: source.customer?.id || '',
    };
};
